import { Observable } from 'rxjs';
import { AuthResult, AuthService } from './shared/services/auth.service';

export function initializeAppFactory(authService: AuthService): () => Observable<AuthResult> {
  return () => authService.auth();
}
